export default "__VITE_ASSET__BGeeseEI__"